import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pressable } from 'react-native';
import { Icon, Row, TextBody, TextParagraph } from '../../atoms';
import { useCallback } from 'react';
export function PaginationControl({ onPress, page, totalPages }) {
    // Vars
    const isStart = page <= 1;
    const isEnd = page >= totalPages;
    // Handlers
    const handlePressFirst = useCallback(() => {
        onPress(1);
    }, [onPress]);
    const handlePressPrev = useCallback(() => {
        onPress(page - 1);
    }, [onPress, page]);
    const handlePressNext = useCallback(() => {
        onPress(page + 1);
    }, [onPress, page]);
    const handlePressLast = useCallback(() => {
        onPress(totalPages);
    }, [onPress, totalPages]);
    // Render
    return (_jsxs(Row.LR, { children: [_jsx(Pressable, { onPress: handlePressFirst, disabled: isStart, children: _jsx(Icon, { name: "FirstPage", color: isStart ? 'tertiary' : 'primary' }) }), _jsx(Pressable, { onPress: handlePressPrev, disabled: isStart, children: _jsx(Icon, { name: "ChevronLeft", color: isStart ? 'tertiary' : 'primary' }) }), _jsxs(TextParagraph, { mx: "4", children: [_jsx(TextBody, { color: "primary", children: "Page " }), _jsxs(TextBody, { em: true, children: [page, " "] }), _jsx(TextBody, { color: "primary", children: "of " }), _jsx(TextBody, { em: true, children: totalPages })] }), _jsx(Pressable, { onPress: handlePressNext, disabled: isEnd, children: _jsx(Icon, { name: "ChevronRight", color: isEnd ? 'tertiary' : 'primary' }) }), _jsx(Pressable, { onPress: handlePressLast, disabled: isEnd, children: _jsx(Icon, { name: "LastPage", color: isEnd ? 'tertiary' : 'primary' }) })] }));
}
